/*
 * Package: WebVideo.I18n
 * Version: $Id$
 * Copyright (c) 2011-2019 Sergey Leonov
 */

function I18n() {}
I18n.DICTIONARY = {};

I18n.t = function(key, replace) {
  var value = I18n.DICTIONARY[key];
  if(typeof(value) == 'undefined' || value == null) {
    value = key;
  }
  if(Array.isArray(replace)) {
    for (var i=0; i<replace.length; i++) {
      value = value.split('{'+(i+1)+'}').join(replace[i]);
    }
  }
  return value;
};